import { FORMULA_LIST_SUCCESS, FORMULA_DETAIL_SUCCESS, FETCH_START, FETCH_END } from './ActionTypes';
import axios from '../../../../axios.conf';
import { history } from '../../../../components/Helpers';
import { toast } from 'react-toastify';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../../components/ExecutionLogHandler';

export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};

export const getFormulasListSuccess = (data) => {
  return {
    type: FORMULA_LIST_SUCCESS,
    data,
  };
};


export const getFormulasList = (pagination, limit, sourceType, applicationType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getFormulasListAPI(pagination, limit, sourceType, applicationType)
      .then(async (response) => {
        dispatch(fetchEnd());
        dispatch(getFormulasListSuccess(response.data.response));
        const logNumber = response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
      })
      .catch(async (error) => {
        dispatch(fetchEnd());
        const logNumber = error?.response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
      });
  };
};


const getFormulasListAPI = (pagination, limit, sourceType, applicationType) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  const appType = applicationType || sessionStorage.getItem('application') || 'Price Management';

  if (sourceType)
    result = axios.get(
      'formula?page=' +
      pagination +
      '&limit=' +
      limit +
      '&source_data_type=' +
      sourceType +
      '&application_type=' +
      appType,
      { headers: headers },
    );
  else
    result = axios.get(
      'formula?page=' +
      pagination +
      '&limit=' +
      limit +
      '&application_type=' +
      (appType === 'Integration Studio'
        ? 'Customer Rebate'
        : appType),
      { headers: headers },
    );
  return result;
};

export const submitFormula = (data, id, type) => {
  return (dispatch) => {
    // Returned so callers can react to completion (e.g. refresh a list); resolves
    // with the response on success and undefined on failure.
    return submitFormulaAPI(data, id, type)
      .then(async (response) => {
        const logNumber = response?.data?.log_number;
        if (logNumber) {
          const { hasError } = await handleExecutionLog(dispatch, logNumber);
          // Stay on the form so the user can correct what the log flagged.
          if (hasError) return undefined;
        } else {
          toast.success(response.data.response);
        }
        history.push('/formula-lab');
        dispatch(getFormulasList());
        return response;
      })
      .catch(async (error) => {
        const logNumber = error?.response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
      });
  };
};

const submitFormulaAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'put') {
    result = axios.put('formula/' + id, data, { headers: headers });
  } else if (type === 'delete') {
    result = axios.delete('formula/' + id, data, { headers: headers });
  } else {
    result = axios.post('formula', data, { headers: headers });
  }
  return result;
};

//edit formula
export const getFormulaDetails = (id) => {
  // Returned so callers can tell when the fetch has settled.
  return (dispatch) => {
    return getFormulaDetailsAPI(id)
      .then(async (response) => {
        dispatch(getFormulaDetailsSuccess(response.data.response));
        const logNumber = response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
      })
      .catch(async (error) => {
        const logNumber = error?.response?.data?.log_number;
        if (logNumber) {
          await handleExecutionLog(dispatch, logNumber);
        }
      });
  };
};

const getFormulaDetailsAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('formula/' + id, { headers: headers });
  return result;
};

export const getFormulaDetailsSuccess = (data) => {
  return {
    type: FORMULA_DETAIL_SUCCESS,
    data,
  };
};
